import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouterLink } from '@angular/router';
import { ModalSurveyAnalyticsComponent } from '../modal-survey-analytics/modal-survey-analytics.component';
import moment from 'moment';
import RestService from '../../services/core-rest.service';
import Toast from "../../services/toast.service";

@Component({
	standalone: true,
	selector: 'table-created-surveys',
	templateUrl: './table-created-surveys.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, TranslatePipe, RouterLink,
		ItemNoContentComponent, LoaderOverlayComponent, FormsModule, InputDatepickerNewComponent
	]
})
export class TableCreatedSurveysComponent implements OnInit, OnDestroy {
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private restService: RestService = inject(RestService);
	private toast: Toast = inject(Toast);
	
	@Input() pageSize: any | undefined;
	@Input() surveys: any;
	@Output() surveysChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Input() questionnaireCode: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	isMobileView: boolean;

	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.isMobileView = window.matchMedia('(max-width: 768px)').matches;
		this.vm.filter = {
			orderBy: 'created',
			ascending: false
		};
		this.vm.language = this.vm.user.deviceLanguage;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.surveyFetchStart = 0;
		this.vm.includeInsurance = false;
		this.vm.loading = true;
		this.vm.minEndDate = moment().add(1, 'day').toDate();
		this.vm.editingEndDateIndex = null;

		this.loadSurveys(true, true);
		
		this.vm.loadSurveys = this.loadSurveys;
		this.vm.setFilter = this.setFilter;
		this.vm.deleteSurvey = this.deleteSurvey;
		this.vm.compareDates = this.compareDates;
		this.vm.getSurveyStatus = this.getSurveyStatus;
		this.vm.truncate = this.truncate;
		this.vm.getPercentageForProgress = this.getPercentageForProgress;
		this.vm.showSurveyAnalytics = this.showSurveyAnalytics;
		this.vm.openSurveyResults = this.openSurveyResults;
		this.vm.isComplianceAssessmentSurvey = this.isComplianceAssessmentSurvey;
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadSurveys();
				}
			})
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Employees.ADDED, () => {
				this.loadSurveys(true);
				this.vm.currentPage = 0;
			})
		);
		this.vm.toggleEditing = this.toggleEditing;
		this.vm.saveNewEndDate = this.saveNewEndDate;
		this.vm.cancelEdit = this.cancelEdit;
		this.vm.sendReminder = this.sendReminder;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	loadSurveys(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
			this.vm.surveyFetchStart = 0;
			this.vm.currentPage = 0;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var existingSurveys = isInitial ? [] : (this.vm.surveys || []);
		var targetSurveyCount = (this.vm.currentPage + 2) * this.vm.pageSize;
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: this.vm.surveyFetchStart || 0,
			orderBy: this.vm.filter.orderBy || 'created',
			ascending: this.vm.filter.ascending || false,
			language: this.vm.language
		};
		
		this.businessRestServices.getSurveys(params, (surveys) => {
			var fetchedSurveys = surveys || [];
			this.vm.surveyFetchStart = params.start + fetchedSurveys.length;
			if (fetchedSurveys.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			surveys = this.filterSurveys(fetchedSurveys);
			var loadedSurveys = existingSurveys.concat(surveys);
			if (!this.vm.endReached && loadedSurveys.length < targetSurveyCount) {
				this.vm.surveys = loadedSurveys;
				this.loadSurveys(false, hasLoader);
				return;
			}
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.surveys = loadedSurveys;
					this.surveysChange.emit(this.vm.surveys);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.surveys = loadedSurveys;
				this.surveysChange.emit(this.vm.surveys);
			}
		});
	}

	filterSurveys(surveys) {
		var questionnaireCode = this.normalizeQuestionnaireCode(this.vm.questionnaireCode);
		return (surveys || []).filter((survey) => {
			var surveyCode = this.getSurveyQuestionnaireCode(survey);
			if (questionnaireCode) {
				return surveyCode === questionnaireCode;
			}
			return surveyCode !== 'COMPLIANCE_ASSESSMENT';
		});
	}

	getSurveyQuestionnaireCode(survey) {
		return this.normalizeQuestionnaireCode(
			survey?.questionnaire?.codeName ||
			survey?.questionnaire?.codename ||
			survey?.questionnaire?.code ||
			survey?.questionnaireCode ||
			survey?.questionnaire?.description
		);
	}

	normalizeQuestionnaireCode(value) {
		return (value || '').toString().toUpperCase().replace(/[\s-]+/g, '_');
	}
	
	deleteSurvey(survey) {
	    if (!survey || survey.processing) return;
		
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Surveys.Confirm_Delete_Survey')
				.replace('%s', survey.questionnaire.description)
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				survey.processing = true;
				var handleUpdate = () => {
					survey.deleted = true;
					survey.processing = false;
				};
				var errorCallback = (err) => {
					survey.processing = false;
					console.log(err);
				}
				this.businessRestServices.deleteSurvey({ surveyId: survey.id }, handleUpdate, errorCallback);
			}
		});
	}

	compareDates(date) {
	    var startDate = moment(date).toDate();
	    var now = moment(new Date()).toDate();
	    return now < startDate;
	}

	getPercentageForProgress(respondedCount, sentCount) {
	    respondedCount = respondedCount ? respondedCount : 0;
	    return Math.round((respondedCount * 100) / sentCount) + '%';
	}

	showSurveyAnalytics(survey) {
		if (this.isComplianceAssessmentSurvey(survey)) {
			this.openSurveyResults(survey);
			return;
		}
		console.log(survey);
		this.dialogServices.show({
			controller: ModalSurveyAnalyticsComponent,
			surveyData: survey,
			width: '500px',
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}

	openSurveyResults(survey) {
		if (!survey || survey.processing) return;
		this.angularRoutingHelperService.setPath('/compliance/' + this.getComplianceAssessmentRequestId(survey) + '/results');
	}

	getComplianceAssessmentRequestId(survey) {
		return survey.questionnaireRequestId || survey.requestId || survey.questionnaireRequest?.id || survey.id;
	}

	isComplianceAssessmentSurvey(survey) {
		return this.getSurveyQuestionnaireCode(survey) === 'COMPLIANCE_ASSESSMENT';
	}
	
	getSurveyStatus(survey) {
	    if (survey) {
	        if (survey.status === 'ACTIVE') {
	            return this.angularFilterHelperService.translate('Surveys.Active');
	        } else if (survey.status === 'PENDING') {
	            return this.angularFilterHelperService.translate('Surveys.Pending');
	        } else if (survey.status === 'CLOSED') {
	            return this.angularFilterHelperService.translate('Surveys.Closed');
	        }
	    } else {
	        return "";
	    }
	}
	
	setFilter(name) {
		this.vm.filter = this.vm.filter || {};
		this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		this.vm.filter.orderBy = name;
		
		this.loadSurveys(true);
	}
	
	truncate(text, size) {
	    return text.length > size ? text.slice(0, size - 1) + "…" : text;
	}

	toggleEditing(index: number) {
		this.vm.editingEndDateIndex = index;
	}

	saveNewEndDate(survey: any, newEndDate) {
		this.vm.editingEndDateIndex = null;
		this.vm.loading = true;

		var params: any = {
			endDate: moment(newEndDate).format('YYYYMMDD'),
			questionnaireRequestId: survey.id
		};
		this.updateSurvey(params);
	}

	updateSurvey(params: any) {
		this.restService.updateSurvey(params)
			.then((response) => {
				this.vm.loading = false;
				window.location.reload();
			})
			.catch((error) => {
				console.log(error);
				this.vm.loading = false;
			});
	}

	cancelEdit() {
		this.vm.editingEndDateIndex = null;
	}

	sendReminder(survey) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Surveys.Send_Survey_Reminder_Confirmation')
				.replace('%s', survey.questionnaire.description)
		});

		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.restService.sendSurveyReminder({questionnaireRequestId: survey.id})
					.then((response) => {
						this.toast.showAsync(
							this.angularFilterHelperService.translate('Surveys.Toast_Message_Success').replace('%s', survey.questionnaire.description),
							undefined,
							10000
						);
					})
					.catch((error) => {
						console.log(error);
					});
			}
		});
	}
}
